/* eslint-disable no-param-reassign */
import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { User } from '../types/local';
import type { RouterOutput } from '../utils/trcp';

export const NO_ACTIVE_SCHOOL_ID = 'activeSchoolId-not-set';
interface Props {
	booting: boolean;
	activeSchoolId: string;
	setActiveSchoolId: (schoolId: string) => void;
	setBooting: (booting: boolean) => void;
	token?: string;
	setToken: (token?: string) => void;
	loginFlowVisible: boolean;
	setLogfinFlowVisible: (visible: boolean) => void;
	welcomeSuccessModalVisible: boolean;
	setWelcomeSuccessModalVisible: (visible: boolean) => void;
	isAppBooting: boolean;
	user?: User;
	setUser: (user?: User) => void;
	drawerStudentId?: string;
	setUserCardId: (userId?: string) => void;
	drawerVersion: number;
	incrementDrawerVersion: () => void;
	setPartialUser: (user: Partial<User>) => void;
	serverConfig?: RouterOutput['app']['getServerConfig'];
	setServerConfig: (config: RouterOutput['app']['getServerConfig']) => void;

	//

	//
	// groupUserSettings?: RouterOutput['user']['me']['groupUserSettings'];
}

export const useSystemStore: UseBoundStore<StoreApi<Props>> = create(
	immer<Props>(set => ({
		drawerVersion: 0,
		incrementDrawerVersion: () =>
			set(state => {
				state.drawerVersion += 1;
			}),
		config: undefined,
		drawerStudentId: undefined,
		setUserCardId: (userId?: string) => set({ drawerStudentId: userId, drawerVersion: 0 }),

		activeSchoolId: NO_ACTIVE_SCHOOL_ID,
		setActiveSchoolId: schoolId => set({ activeSchoolId: schoolId }),
		booting: true,
		setBooting: booting => set({ booting }),
		token: undefined,
		setToken: token => set({ token }),
		isAppBooting: false,
		user: undefined,
		setUser: user =>
			set({
				user,
				booting: false,
				activeSchoolId: user?.activeSchoolId,
				// groupSettings: user?.groupSettings,
				// groupUserSettings: user?.groupUserSettings,
			}),
		welcomeSuccessModalVisible: false,
		setWelcomeSuccessModalVisible: (visible: boolean) => set({ welcomeSuccessModalVisible: visible }),
		loginFlowVisible: false,
		setLogfinFlowVisible: (visible: boolean) => set({ loginFlowVisible: visible }),
		setPartialUser: (partialUser: Partial<User>) =>
			set(state => {
				Object.keys(partialUser).forEach(key => {
					if (state.user) {
						(state.user as any)[key] = (partialUser as any)[key];
					}
				});
			}),
		setServerConfig: (config: RouterOutput['app']['getServerConfig']) => set({ serverConfig: config }),

		//
		isGroupBlocked: false,
	})),
);
